<template>
  <loading :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="fullPage"
      :color="color"
      :loader="loader"
      :background-color="bgColor"
      :height="height"
      :width="width">
  </loading>
</template>

<script>
import Loading from 'vue-loading-overlay'

export default {
  name: 'Loader',

  components: {
    Loading
  },
  data () {
    return {
      color: '#1568C1',
      bgColor: '#E3E3E3',
      loader: 'spinner',
      height: 70,
      width: 70
    }
  },

  props: {
    isLoading: { type: Boolean, required: true },
    fullPage: { type: Boolean, required: false, default: true }
  }
}
</script>
